/**
 * src/api/http.js
 */
import axios from "axios";
import qs from "qs";
import CookieService from "./CookieService";

/**
 *
 * parse error response
 */
/**
 * O interceptor rejeita com `{ messages: [corpo] }`, então `error.response` não existe
 * do lado de quem chama — ler `error.response.data.message` devolve sempre undefined e
 * a mensagem do backend nunca chega à tela.
 */
export function errorBody(error) {
  const first = error?.messages?.[0];
  return first && typeof first === "object" ? first : null;
}

export function errorMessage(error, fallback) {
  const first = error?.messages?.[0];
  if (typeof first === "string") return first;
  return first?.message || fallback;
}

function parseError(messages, status) {
  // `status` é adicional: quem já lia `messages` não muda. Sem ele, quem chama não
  // consegue distinguir 409 de 410 de 500 — a página do paciente depende disso para
  // mostrar "já respondido" e "formulário expirado" em vez do erro genérico.
  // error
  if (messages) {
    if (messages instanceof Array) {
      return Promise.reject({ messages: messages, status });
    } else {
      return Promise.reject({ messages: [messages], status });
    }
  } else {
    return Promise.reject({ messages: ["error"], status });
  }
}

/**
 * parse response
 */
function parseBody(response) {
  //  if (response.status === 200 && response.data.status.code === 200) { // - if use custom status code
  if (response.status === 200) {
    return response.data.result;
  } else {
    return this.parseError(response.data.messages);
  }
}

/**
 * axios instance
 */
let instance = axios.create({
  baseURL: process.env.REACT_APP_TAKAOKABOTS_API_URL,
  paramsSerializer: function (params) {
    return qs.stringify(params, { indices: false });
  },
});

// request header
instance.interceptors.request.use(
  (config) => {
    const apiToken = CookieService.get("api_token");
    if (apiToken) {
      config.headers["Authorization"] = `Bearer ${apiToken}`;
    }
    config.headers["Accept"] = "application/json";
    // config.headers = { Authorization: "Bearer " + apiToken, Accept: "application/json" };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response parse
instance.interceptors.response.use(
  (response) => {
    //return parseBody(response);
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    console.warn("Error status", status ?? "network");
    if (error.response) {
      return parseError(error.response.data, status);
    }
    return Promise.reject(error);
  }
);

export function setHttpBaseURL(baseURL) {
  if (baseURL) {
    instance.defaults.baseURL = baseURL;
  }
}

export const http = instance;
